<template>
    <div class="home">
        home page
    </div>
</template>

<script>
import Core from 'core'

export default {
    name: 'Home',
    mounted() {
        // this.checkUrl()
    },
    methods: {
        checkUrl() {
            console.log(this.$route.query)
        }
    }
}
</script>
